<div class="tmw-autocomplete position-relative">
  <div class="input-group input-group-sm">
    <input
      type="text"
      class="form-control form-control-sm"
      [attr.id]="id"
      [attr.name]="name"
      [(ngModel)]="searchText"
      [disabled]="disableInput"
      [placeholder]="textDefault"
      (ngModelChange)="onInputChange()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)"
      autocomplete="off"
    />
    <button *ngIf="searchText && !disableInput" type="button" class="btn btn-outline-secondary" (mousedown)="clearSelection()">
      <i class="bi bi-x"></i>
    </button>
  </div>
  <ul *ngIf="isOpen && filteredList.length" class="dropdown-menu show w-100" style="max-height:220px; overflow-y:auto; position:absolute; z-index:1055;">
    <li *ngIf="!isRequired" (mousedown)="clearSelection()">
      <span class="dropdown-item text-muted fst-italic">{{ textDefault }}</span>
    </li>
    @for (item of filteredList; track item.id; let i = $index) {
      <li (mousedown)="selectItem(item)">
        <span class="dropdown-item" [class.active]="i === activeIndex">{{ item.formated }}</span>
      </li>
    }
  </ul>
</div>
<span *ngIf="typeRessource && enableEdit()" class="inline-link">
  <a (click)="edit($event); (false)">
    <i class="bi bi-key-fill"></i>
  </a>
</span>
